<template>
    <GreyButton class="pt-3 pb-3 w-100 click-pointer" style="border-radius: 7px;">
        <div class="col-3 d-flex justify-content-center align-items-center">
            <div class="icon-bg p-2" :style="{ background: iconBg }">
                <i :class="icon" class="icon-size" :style="{ color: iconColor }"></i>
            </div>
        </div>

        <div class="col-9">
            <div>
                <strong>
                    {{ title }}
                </strong>
            </div>
            <div class="text-muted">
                {{ subtitle }}
            </div>
        </div>
    </GreyButton>
</template>

<script>
import GreyButton from './GreyButton.vue'

export default{
    name: "ContactModalIconContainer",

    components: {
        GreyButton
    },

    props: {
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        iconColor: {
            type: String,
            default: ''
        },
        iconBg: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.icon-bg {
    border-radius: 100%;
    height: 60px;
    width: 60px;
    display: inline-block;
    display: flex;
    justify-content: center;
    align-items: center;
}
.icon-size {
    font-size: 30px;
}
.click-pointer {
    cursor: pointer;
}
</style>
